import {
	FuelConsumptionUnitEnum,
	VehicleAllocationEnum,
	VehicleBodyTypeEnum,
	VehicleDriveTrainTypeEnum,
	VehicleElectricBatteryTypeEnum,
	VehicleEmissionsUnitCO2Enum,
	VehicleEngineSizeUnitEnum,
	VehicleFuelTankCapacityUnitEnum,
	VehicleOdometerUnitEnum,
	VehiclePowerPlantTypeEnum,
	VehicleStatusEnum,
	VehicleSteeringPositionEnum,
	VehicleTransmissionTypeEnum,
	VehicleFuelTypeEnum,
	vehicleStatusToColor,
	VehicleTypeEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { SelectItem } from 'app/shared/models/select-item.type';

export const VEHICLE_STATUSES: SelectItem<VehicleStatusEnum>[] = [
	{
		value: VehicleStatusEnum.IN_PARK,
		displayValue: 'vehicles|status|in-park',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.IN_PARK),
	},
	{
		value: VehicleStatusEnum.RENTED,
		displayValue: 'vehicles|status|rented',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.RENTED),
	},
	{
		value: VehicleStatusEnum.RESERVED,
		displayValue: 'vehicles|status|reserved',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.RESERVED),
	},
	{
		value: VehicleStatusEnum.IN_MAINTENANCE,
		displayValue: 'vehicles|status|in-maintenance',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.IN_MAINTENANCE),
	},
	{
		value: VehicleStatusEnum.HARD_HOLD,
		displayValue: 'vehicles|status|hard-hold',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.HARD_HOLD),
	},
	{
		value: VehicleStatusEnum.RESERVED_MAINTENANCE,
		displayValue: 'vehicles|status|reserved-maintenance',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.RESERVED_MAINTENANCE),
	},
	{
		value: VehicleStatusEnum.OUT_OF_SERVICE,
		displayValue: 'vehicles|status|out-of-service',
		pillColor: vehicleStatusToColor(VehicleStatusEnum.OUT_OF_SERVICE),
	},
];
export const VEHICLE_BODY_TYPE = [
	{
		value: VehicleBodyTypeEnum.SEDAN,
		displayValue: 'vehicles|body-type|sedan',
	},
	{
		value: VehicleBodyTypeEnum.COUPE,
		displayValue: 'vehicles|body-type|coupe',
	},
	{
		value: VehicleBodyTypeEnum.CONVERTIBLE,
		displayValue: 'vehicles|body-type|convertible',
	},
	{
		value: VehicleBodyTypeEnum.ROADSTER,
		displayValue: 'vehicles|body-type|roadster',
	},
	{
		value: VehicleBodyTypeEnum.HATCHBACK,
		displayValue: 'vehicles|body-type|hatchback',
	},
	{
		value: VehicleBodyTypeEnum.WAGON,
		displayValue: 'vehicles|body-type|wagon',
	},
	{
		value: VehicleBodyTypeEnum.SUV,
		displayValue: 'vehicles|body-type|suv',
	},
	{
		value: VehicleBodyTypeEnum.JEEP,
		displayValue: 'vehicles|body-type|jeep',
	},
	{
		value: VehicleBodyTypeEnum.JEEP4x4,
		displayValue: 'vehicles|body-type|jeep4x4',
	},
	{
		value: VehicleBodyTypeEnum.CUV,
		displayValue: 'vehicles|body-type|CUV',
	},
	{
		value: VehicleBodyTypeEnum.STREETCAR,
		displayValue: 'vehicles|body-type|streetcar',
	},
	{
		value: VehicleBodyTypeEnum.PICKUP,
		displayValue: 'vehicles|body-type|pickup',
	},
	{
		value: VehicleBodyTypeEnum.TRAILER,
		displayValue: 'vehicles|body-type|trailer',
	},
	{
		value: VehicleBodyTypeEnum.MINIVAN,
		displayValue: 'vehicles|body-type|minivan',
	},
	{
		value: VehicleBodyTypeEnum.CAMPER,
		displayValue: 'vehicles|body-type|camper',
	},
	{
		value: VehicleBodyTypeEnum.VAN,
		displayValue: 'vehicles|body-type|van',
	},
	{
		value: VehicleBodyTypeEnum.TRUCK,
		displayValue: 'vehicles|body-type|truck',
	},
	{
		value: VehicleBodyTypeEnum.BUS,
		displayValue: 'vehicles|body-type|bus',
	},
	{
		value: VehicleBodyTypeEnum.TRACTOR,
		displayValue: 'vehicles|body-type|tractor',
	},
	{
		value: VehicleBodyTypeEnum.BUGGY,
		displayValue: 'vehicles|body-type|buggy',
	},
	{
		value: VehicleBodyTypeEnum.QUAD_BIKE,
		displayValue: 'vehicles|body-type|quad-bike',
	},
	{
		value: VehicleBodyTypeEnum.SNOWMOBILE,
		displayValue: 'vehicles|body-type|snowmobile',
	},
	{
		value: VehicleBodyTypeEnum.BICYCLE,
		displayValue: 'vehicles|body-type|bicycle',
	},
	{
		value: VehicleBodyTypeEnum.SCOOTER,
		displayValue: 'vehicles|body-type|scooter',
	},
	{
		value: VehicleBodyTypeEnum.MOTORCYCLE,
		displayValue: 'vehicles|body-type|motorcycle',
	},
	{
		value: VehicleBodyTypeEnum.E_BIKE,
		displayValue: 'vehicles|body-type|e-bike',
	},
	{
		value: VehicleBodyTypeEnum.OTHER,
		displayValue: 'vehicles|body-type|other',
	},
];
export const VEHICLE_FUEL_TYPE = [
	{
		value: VehicleFuelTypeEnum.PETROL,
		displayValue: 'vehicles|vehicle-fuel-type|petrol',
	},
	{
		value: VehicleFuelTypeEnum.GAS,
		displayValue: 'vehicles|vehicle-fuel-type|gas',
	},
	{
		value: VehicleFuelTypeEnum.HYBRID,
		displayValue: 'vehicles|vehicle-fuel-type|hybrid',
	},
	{
		value: VehicleFuelTypeEnum.PLUG_IN_HYBRID,
		displayValue: 'vehicles|vehicle-fuel-type|plug-in-hybrid',
	},
	{
		value: VehicleFuelTypeEnum.ELECTRIC,
		displayValue: 'vehicles|vehicle-fuel-type|electric',
	},
];
export const VEHICLE_POWER_PLANT_TYPE = [
	{
		value: VehiclePowerPlantTypeEnum.UNLEADED,
		displayValue: 'vehicles|power-plant-type|unleaded',
	},
	{
		value: VehiclePowerPlantTypeEnum.DIESEL,
		displayValue: 'vehicles|power-plant-type|diesel',
	},
	{
		value: VehiclePowerPlantTypeEnum.HYDROGEN,
		displayValue: 'vehicles|power-plant-type|hydrogen',
	},
	{
		value: VehiclePowerPlantTypeEnum.ELECTRIC,
		displayValue: 'vehicles|power-plant-type|electric',
	},
	{
		value: VehiclePowerPlantTypeEnum.NEAT_ETHANOL,
		displayValue: 'vehicles|power-plant-type|neat-ethanol',
	},
	{
		value: VehiclePowerPlantTypeEnum.METHANOL,
		displayValue: 'vehicles|power-plant-type|methanol',
	},
	{
		value: VehiclePowerPlantTypeEnum.NEAT_METHANOL,
		displayValue: 'vehicles|power-plant-type|neat-methanol',
	},
	{
		value: VehiclePowerPlantTypeEnum.CNG,
		displayValue: 'vehicles|power-plant-type|cng',
	},
	{
		value: VehiclePowerPlantTypeEnum.LNG,
		displayValue: 'vehicles|power-plant-type|lng',
	},
	{
		value: VehiclePowerPlantTypeEnum.LPG,
		displayValue: 'vehicles|power-plant-type|lpg',
	},

	{
		value: VehiclePowerPlantTypeEnum.NATURAL_GAS,
		displayValue: 'vehicles|power-plant-type|natural-gas',
	},
];
export const VEHICLE_TRANSMISSION_TYPE = [
	{
		value: VehicleTransmissionTypeEnum.MANUAL,
		displayValue: 'vehicles|transmission-type|manual',
	},
	{
		value: VehicleTransmissionTypeEnum.AUTOMATIC,
		displayValue: 'vehicles|transmission-type|automatic',
	},
	{
		value: VehicleTransmissionTypeEnum.CVT,
		displayValue: 'vehicles|transmission-type|cvt',
	},
	{
		value: VehicleTransmissionTypeEnum.OTHER,
		displayValue: 'vehicles|transmission-type|other',
	},
];
export const VEHICLE_DRIVE_TRAIN_TYPE = [
	{
		value: VehicleDriveTrainTypeEnum.FRONT_WHEEL_DRIVE,
		displayValue: 'vehicles|drive-train-type|front-wheel-drive',
	},
	{
		value: VehicleDriveTrainTypeEnum.FOUR_BY_FOUR,
		displayValue: 'vehicles|drive-train-type|four-by-four',
	},
	{
		value: VehicleDriveTrainTypeEnum.REAR_WHEEL_DRIVE,
		displayValue: 'vehicles|drive-train-type|rear-wheel-drive',
	},
	{
		value: VehicleDriveTrainTypeEnum.ALL_WHEEL_DRIVE,
		displayValue: 'vehicles|drive-train-type|all-wheel-drive',
	},
	{
		value: VehicleDriveTrainTypeEnum.NON_STANDARDIZED,
		displayValue: 'vehicles|drive-train-type|non-standardized',
	},
];
export const VEHICLE_ALLOCATION_TYPE = [
	{
		value: VehicleAllocationEnum.RENTAL,
		displayValue: 'vehicles|allocation-type|rental',
	},
	{
		value: VehicleAllocationEnum.STAFF,
		displayValue: 'vehicles|allocation-type|staff',
	},
];

export const VEHICLE_ENGINE_SIZE_UNIT = [
	{
		value: VehicleEngineSizeUnitEnum.CC,
		displayValue: 'vehicles|engine-size-unit|cc',
	},
	{
		value: VehicleEngineSizeUnitEnum.CI,
		displayValue: 'vehicles|engine-size-unit|ci',
	},
	{
		value: VehicleEngineSizeUnitEnum.L,
		displayValue: 'vehicles|engine-size-unit|l',
	},
];

export const VEHICLE_FUEL_TANK_CAPACITY = [
	{
		value: VehicleFuelTankCapacityUnitEnum.GALLON,
		displayValue: 'vehicles|tank-capacity|gallon',
	},
	{
		value: VehicleFuelTankCapacityUnitEnum.LITRE,
		displayValue: 'vehicles|tank-capacity|litre',
	},
];

export const VEHICLE_ODOMETER_UNIT = [
	{
		value: VehicleOdometerUnitEnum.KM,
		displayValue: 'vehicles|odometer-unit|km',
	},
	{
		value: VehicleOdometerUnitEnum.MI,
		displayValue: 'vehicles|odometer-unit|mi',
	},
];

export const VEHICLE_STEERING_POSITION = [
	{
		value: VehicleSteeringPositionEnum.CENTER,
		displayValue: 'vehicles|steering-position|center',
	},
	{
		value: VehicleSteeringPositionEnum.LEFT_HAND_DRIVE,
		displayValue: 'vehicles|steering-position|left-hand-drive',
	},
	{
		value: VehicleSteeringPositionEnum.RIGHT_HAND_DRIVE,
		displayValue: 'vehicles|steering-position|right-hand-drive',
	},
];

export const VEHICLE_ELECTRIC_BATTERY_TYPE = [
	{
		value: VehicleElectricBatteryTypeEnum.IRON_PHOSPHATE,
		displayValue: 'vehicles|electric-battery-type|iron-phosphate',
	},
	{
		value: VehicleElectricBatteryTypeEnum.LI_ION,
		displayValue: 'vehicles|electric-battery-type|li-ion',
	},
	{
		value: VehicleElectricBatteryTypeEnum.LI_POLY,
		displayValue: 'vehicles|electric-battery-type|li-poly',
	},
	{
		value: VehicleElectricBatteryTypeEnum.LEAD_ACID,
		displayValue: 'vehicles|electric-battery-type|lead-acid',
	},
	{
		value: VehicleElectricBatteryTypeEnum.LITHIUM_ION,
		displayValue: 'vehicles|electric-battery-type|lithium-ion',
	},
	{
		value: VehicleElectricBatteryTypeEnum.NICKEL_METAL_HYDRIDE,
		displayValue: 'vehicles|electric-battery-type|nickel-metal-hydride',
	},
	{
		value: VehicleElectricBatteryTypeEnum.NICKLE_COBALT_ALUMINUM,
		displayValue: 'vehicles|electric-battery-type|nickel-cobalt-aluminum',
	},
	{
		value: VehicleElectricBatteryTypeEnum.NICKLE_COBALT_MANGANESE,
		displayValue: 'vehicles|electric-battery-type|nickel-cobalt-manganese',
	},
	{
		value: VehicleElectricBatteryTypeEnum.SILICON,
		displayValue: 'vehicles|electric-battery-type|silicon',
	},
];

export const VEHICLE_EMISSIONS_UNIT_CO2 = [
	{
		value: VehicleEmissionsUnitCO2Enum.GRAMS_KM,
		displayValue: 'vehicles|emissions-unit-C02|grams-km',
	},
	{
		value: VehicleEmissionsUnitCO2Enum.GRAMS_MI,
		displayValue: 'vehicles|emissions-unit-C02|grams-mi',
	},
];

export const VEHICLE_FUEL_CONSUMPTION_UNIT = [
	{
		value: FuelConsumptionUnitEnum.LKM,
		displayValue: 'vehicles|fuel-consumption-unit|lkm',
	},
	{
		value: FuelConsumptionUnitEnum.MPG,
		displayValue: 'vehicles|fuel-consumption-unit|mpg',
	},
];

export const VEHICLE_TYPE: SelectItem<VehicleTypeEnum>[] = [
	{
		value: VehicleTypeEnum.CAR,
		displayValue: 'vehicles|type|car',
	},
	{
		value: VehicleTypeEnum.BICYCLE,
		displayValue: 'vehicles|type|bicycle',
	},
	{
		value: VehicleTypeEnum.MOTORBIKE,
		displayValue: 'vehicles|type|motorbike',
	},
	{
		value: VehicleTypeEnum.ATV_BUGGY,
		displayValue: 'vehicles|type|atv-buggy',
	},
];
